import React,{Component} from 'react'
import Header from "../../components/Header";
import Footer from "../Home/Footer"
import {Container} from 'semantic-ui-react'
export default class About extends Component{
render(){
	return(
		<div>
		<Header/>
		<div style={{paddingTop:120,height:500}}>
    <Container>
	   	<h1>About us.</h1>
	    <p>
				Crypto trade is a platform that gives you chance to invest
				your Bitcoin and we trade for you as you  earn 50% of your
				investment every after 15 days and this takes a period of
				45days for every package purchased.
				Each package is inclusive of 10% as admin fee for example
				if one purchases a package of 27.5 your investment will be 25$
				and 2.5$ as admin fee. So you get 12.5$ as payment every after
				15 days and this will be paid   three times per investment
				totaling to 45 days, so this means 50% profit per package purchased.
	    </p>

    </Container>
     </div>
		<Footer/>
		</div>
		)
}


}



// WEBPACK FOOTER //
// ./src/views/about/about.js